// extracted by mini-css-extract-plugin
export var badge = "_si-4";
export var selected = "_si-1";
export var selectedOverlay = "_si-5";
export var thumbnailButton = "_si-0";
export var thumbnailFallback = "_si-3";
export var thumbnailImage = "_si-2";